import { objectValueOrDefault, configQuery, RoutablePage, ValidationGuard, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_JURISDICTION_QUERY, BALANCE_CURRENCY_UPDATED, USER_COUNTRY_UPDATED, BALANCE_CURRENCY_QUERY, USER_COUNTRY_QUERY } from '@gig/magic-messages';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { CoreXMediatorType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/createUserTransactionLimit';
import { store } from '../../../store/index.js';
import { validationMixin } from 'vuelidate';
import { required, integer, minValue, maxValue } from 'vuelidate/lib/validators';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';
import { CoreXLimitDuration, CoreXLimitType, CoreXGamingLimitType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/getUserTransactionLimits';
import { isUKGC } from '@gig/magic-jurisdictions';
import { Inputs } from '../../../types/index.js';

var DEFAULT_MAX_CAP = 10000;
var limitErrors = {
    NO_CHANGE_IN_LIMIT_AMOUNT: 'create-limits.error.no-change-in-limit-amount',
    PENDING_USER_ACTION_REQUIRED_ON_ANOTHER_LIMIT: 'create-limits.error.another-limit-in-pending-action',
};
var CreateLimitsComponent = /** @class */ (function (_super) {
    __extends(CreateLimitsComponent, _super);
    function CreateLimitsComponent() {
        var _a;
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.CoreXLimitDuration = CoreXLimitDuration;
        _this.CoreXLimitType = CoreXLimitType;
        _this.duration = '';
        _this.amount = '';
        _this.period = CoreXLimitDuration.ONE_DAY;
        _this.translations = (_a = {},
            _a[CoreXGamingLimitType.DEPOSIT] = {
                title: 'create-limits.deposit.title',
                introduction: 'create-limits.deposit.introduction',
            },
            _a[CoreXGamingLimitType.NET_DEPOSIT] = {
                title: 'create-limits.net-deposit.title',
                introduction: 'create-limits.net-deposit.introduction',
            },
            _a[CoreXGamingLimitType.WAGERING_CASINO] = {
                title: 'create-limits.wager-casino.title',
                introduction: 'create-limits.wager-casino.introduction',
            },
            _a[CoreXGamingLimitType.LOSS_CASINO] = {
                title: 'create-limits.loss-casino.title',
                introduction: 'create-limits.loss-casino.introduction',
            },
            _a[CoreXGamingLimitType.WITHDRAWAL] = {
                title: 'create-limits.withdrawal.title',
                introduction: 'create-limits.withdrawal.introduction',
            },
            _a[CoreXGamingLimitType.WAGERING_SPORTS] = {
                title: 'create-limits.wager-sports.title',
                introduction: 'create-limits.wager-sports.introduction',
            },
            _a[CoreXGamingLimitType.LOSS_SPORTS] = {
                title: 'create-limits.loss-sports.title',
                introduction: 'create-limits.loss-sports.introduction',
            },
            _a[CoreXGamingLimitType.SESSION] = {
                title: 'create-limits.session.title',
                introduction: 'create-limits.session.introduction',
            },
            _a[CoreXGamingLimitType.MAX_WAGER_CASINO] = {
                title: 'create-limits.max-wager-casino.title',
                introduction: 'create-limits.max-wager-casino.introduction',
            },
            _a[CoreXGamingLimitType.MAX_WAGER_SPORTS] = {
                title: 'create-limits.max-wager-sports.title',
                introduction: 'create-limits.max-wager-sports.introduction',
            },
            _a);
        _this.section = CoreXGamingLimitType.MAX_WAGER_CASINO;
        /**
         * Enabled limits ids e.g. [1, 2, 3, 4]
         */
        _this.enabledLimits = [];
        /**
         * Defines which is the maximum value the user can enter as a limit in the Set a limit page
         */
        _this.responsibleGamingLimitCap = [];
        /**
         * Limit periods enabled for a specific limit
         */
        _this.responsibleGamingLimitPeriods = {};
        _this.subscriptions = [];
        return _this;
    }
    CreateLimitsComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.initializeVariables()];
                    case 1:
                        _a.sent();
                        this.section = !!this.sections.length
                            ? this.sections[0].limitType
                            : CoreXGamingLimitType.MAX_WAGER_CASINO;
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateLimitsComponent.prototype.destroyed = function () {
        this.subscriptions.forEach(function (subscription) {
            return subscription.unsubscribe();
        });
    };
    Object.defineProperty(CreateLimitsComponent.prototype, "sections", {
        get: function () {
            var _a;
            var _this = this;
            // this is a sort helper and not a representation of actual limit type values
            var LIMITS_ORDER = (_a = {},
                _a[CoreXGamingLimitType.MAX_WAGER_CASINO] = 0,
                _a[CoreXGamingLimitType.MAX_WAGER_SPORTS] = 1,
                _a[CoreXGamingLimitType.DEPOSIT] = 2,
                _a[CoreXGamingLimitType.WITHDRAWAL] = 3,
                _a[CoreXGamingLimitType.SESSION] = 4,
                _a[CoreXGamingLimitType.LOSS_CASINO] = 5,
                _a[CoreXGamingLimitType.LOSS_SPORTS] = 6,
                _a[CoreXGamingLimitType.WAGERING_CASINO] = 7,
                _a[CoreXGamingLimitType.WAGERING_SPORTS] = 8,
                _a[CoreXGamingLimitType.NET_DEPOSIT] = 9,
                _a);
            this.limits = Object.values(CoreXGamingLimitType).map(function (value) {
                return {
                    isVisible: false,
                    limitType: value,
                };
            });
            // TODO: remove this once we can rely on the api
            // this is bc we are not relying on the response 'visible' value
            return this.limits
                .filter(function (limit) { return _this.enabledLimits.includes(limit.limitType); })
                .sort(function (limit, nextLimit) {
                return LIMITS_ORDER[limit.limitType] -
                    LIMITS_ORDER[nextLimit.limitType];
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateLimitsComponent.prototype, "sectionTitle", {
        get: function () {
            return this.getTranslationKey(this.section, 'title');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateLimitsComponent.prototype, "sectionIntroduction", {
        get: function () {
            return this.getTranslationKey(this.section, 'introduction');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateLimitsComponent.prototype, "sectionOptions", {
        get: function () {
            var _this = this;
            return Object.entries(this.sections).map(function (_a) {
                var section = _a[1];
                return ({
                    name: _this.$t(_this.getTranslationKey(section.limitType, 'title')),
                    value: section.limitType,
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateLimitsComponent.prototype, "invalidData", {
        get: function () {
            return this.$v.$invalid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateLimitsComponent.prototype, "maxDurationError", {
        get: function () {
            return this.$t('create-limits.error.max', {
                minValue: 30,
                maxValue: 1440,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateLimitsComponent.prototype, "maxAmountError", {
        get: function () {
            return this.$t('create-limits.error.max', {
                minValue: 0,
                maxValue: this.getLimitCap(),
            });
        },
        enumerable: false,
        configurable: true
    });
    CreateLimitsComponent.prototype.getTranslationKey = function (type, key) {
        if (this.translations[type]) {
            return this.translations[type][key];
        }
        return '';
    };
    CreateLimitsComponent.prototype.getInputsByType = function (type) {
        var _a;
        var inputsByLimitType = (_a = {},
            _a[CoreXGamingLimitType.SESSION] = [Inputs.DURATION],
            _a[CoreXGamingLimitType.DEPOSIT] = [Inputs.PERIOD, Inputs.AMOUNT],
            _a[CoreXGamingLimitType.NET_DEPOSIT] = [Inputs.PERIOD, Inputs.AMOUNT],
            _a[CoreXGamingLimitType.WAGERING_CASINO] = [
                Inputs.PERIOD,
                Inputs.AMOUNT,
            ],
            _a[CoreXGamingLimitType.LOSS_CASINO] = [Inputs.PERIOD, Inputs.AMOUNT],
            _a[CoreXGamingLimitType.WAGERING_SPORTS] = [
                Inputs.PERIOD,
                Inputs.AMOUNT,
            ],
            _a[CoreXGamingLimitType.LOSS_SPORTS] = [Inputs.PERIOD, Inputs.AMOUNT],
            _a[CoreXGamingLimitType.WITHDRAWAL] = [Inputs.PERIOD, Inputs.AMOUNT],
            _a[CoreXGamingLimitType.MAX_WAGER_CASINO] = [Inputs.AMOUNT],
            _a[CoreXGamingLimitType.MAX_WAGER_SPORTS] = [Inputs.AMOUNT],
            _a);
        return inputsByLimitType[type] ? inputsByLimitType[type] : [];
    };
    CreateLimitsComponent.prototype.isInputVisible = function (type, input) {
        var inputs = this.getInputsByType(type);
        if (inputs) {
            return inputs.includes(input);
        }
        return false;
    };
    CreateLimitsComponent.prototype.checkVisibility = function (type, section) {
        if (type === CoreXLimitDuration.ONE_DAY) {
            return !this.responsibleGamingLimitPeriods[section].DAILY;
        }
        else if (type === CoreXLimitDuration.ONE_WEEK) {
            return !this.responsibleGamingLimitPeriods[section].WEEKLY;
        }
        else if (type === CoreXLimitDuration.ONE_MONTH) {
            return !this.responsibleGamingLimitPeriods[section].MONTHLY;
        }
        else {
            return true;
        }
    };
    Object.defineProperty(CreateLimitsComponent.prototype, "showDuration", {
        /**
         * Used in the view to toggle the duration input
         */
        get: function () {
            return this.isInputVisible(this.section, Inputs.DURATION);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateLimitsComponent.prototype, "showPeriod", {
        /**
         * Used in the view to toggle the period radios
         */
        get: function () {
            return this.isInputVisible(this.section, Inputs.PERIOD);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateLimitsComponent.prototype, "showAmount", {
        /**
         * Used in the view to toggle the amount input
         */
        get: function () {
            return this.isInputVisible(this.section, Inputs.AMOUNT);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Duration radio are hidden to the user for this types
     * @param limitType
     */
    CreateLimitsComponent.prototype.getPeriod = function (limitType) {
        var isVisible = this.isInputVisible(limitType, Inputs.PERIOD);
        // This is what backend wands for session limit
        if (limitType === CoreXGamingLimitType.SESSION) {
            return CoreXLimitDuration.ONE_DAY;
        }
        // This is what backend wants for max stake per bet
        if (!isVisible) {
            return CoreXLimitDuration.NO_DURATION;
        }
        return this.period;
    };
    /**
     * limitAmount sent to api might refer to duration or amount values
     * @param limitType
     */
    CreateLimitsComponent.prototype.getLimitAmount = function (limitType) {
        var isDurationVisible = this.isInputVisible(limitType, Inputs.DURATION);
        if (isDurationVisible) {
            return parseInt(this.duration, 10);
        }
        return parseInt(this.amount, 10);
    };
    /**
     * getLimitCap is the maximum value allowed for amount, according to user's currency
     * @return limitCap
     */
    CreateLimitsComponent.prototype.getLimitCap = function () {
        if (!this.responsibleGamingLimitCap) {
            return DEFAULT_MAX_CAP;
        }
        var period = this.getPeriod(this.section);
        var gamingLimits = this.responsibleGamingLimitCap;
        var sectionIndex = this.section - 1;
        var periodIndex = this.getPeriodIndex(period);
        var parsedLimit = gamingLimits[sectionIndex][periodIndex];
        return isNaN(parsedLimit) ? DEFAULT_MAX_CAP : parsedLimit;
    };
    CreateLimitsComponent.prototype.getPeriodIndex = function (period) {
        switch (period) {
            case CoreXLimitDuration.ONE_DAY:
                return 0;
            case CoreXLimitDuration.ONE_WEEK:
                return 1;
            case CoreXLimitDuration.ONE_MONTH:
                return 2;
            default:
                return 0;
        }
    };
    CreateLimitsComponent.prototype.getUserTransactionLimitType = function (type) {
        switch (type) {
            case CoreXGamingLimitType.DEPOSIT:
                return CoreXLimitType.DEPOSIT;
            case CoreXGamingLimitType.NET_DEPOSIT:
                return CoreXLimitType.NET_DEPOSIT;
            case CoreXGamingLimitType.WITHDRAWAL:
                return CoreXLimitType.WITHDRAWAL;
            case CoreXGamingLimitType.LOSS_CASINO:
            case CoreXGamingLimitType.LOSS_SPORTS:
                return CoreXLimitType.LOSS;
            case CoreXGamingLimitType.WAGERING_CASINO:
            case CoreXGamingLimitType.WAGERING_SPORTS:
                return CoreXLimitType.WAGERING;
            case CoreXGamingLimitType.SESSION:
                return CoreXLimitType.SESSION;
            case CoreXGamingLimitType.MAX_WAGER_CASINO:
            case CoreXGamingLimitType.MAX_WAGER_SPORTS:
                return CoreXLimitType.MAX_WAGER;
        }
    };
    CreateLimitsComponent.prototype.getDurationFromLimitAmount = function (amount) {
        return amount == 1440 ? CoreXLimitDuration.ONE_DAY : "PT" + amount + "M";
    };
    CreateLimitsComponent.prototype.setLimit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var period, limitAmount, _a, response, response, response, response, response, response, currentJurisdiction, lastFinancialLimitReviewOnUtc, response, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isLoading) {
                            return [2 /*return*/];
                        }
                        period = this.getPeriod(this.section);
                        limitAmount = this.getLimitAmount(this.section);
                        this.isLoading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 20, 21, 22]);
                        _a = this.section;
                        switch (_a) {
                            case CoreXGamingLimitType.SESSION: return [3 /*break*/, 2];
                            case CoreXGamingLimitType.MAX_WAGER_CASINO: return [3 /*break*/, 4];
                            case CoreXGamingLimitType.MAX_WAGER_SPORTS: return [3 /*break*/, 6];
                            case CoreXGamingLimitType.LOSS_CASINO: return [3 /*break*/, 8];
                            case CoreXGamingLimitType.WAGERING_CASINO: return [3 /*break*/, 8];
                            case CoreXGamingLimitType.LOSS_SPORTS: return [3 /*break*/, 10];
                            case CoreXGamingLimitType.WAGERING_SPORTS: return [3 /*break*/, 10];
                            case CoreXGamingLimitType.DEPOSIT: return [3 /*break*/, 12];
                            case CoreXGamingLimitType.NET_DEPOSIT: return [3 /*break*/, 17];
                            case CoreXGamingLimitType.WITHDRAWAL: return [3 /*break*/, 17];
                        }
                        return [3 /*break*/, 19];
                    case 2: return [4 /*yield*/, magic.methods.responsibleGaming.createUserCumulativeSessionLimit(this.getDurationFromLimitAmount(limitAmount))];
                    case 3:
                        response = _b.sent();
                        if (response) {
                            this.showSuccessNotification();
                        }
                        else {
                            this.showErrorNotification();
                        }
                        return [3 /*break*/, 19];
                    case 4: return [4 /*yield*/, magic.methods.responsibleGaming.createUserWagerLimit(this.currencyCode, limitAmount, CoreXMediatorType.CASINO)];
                    case 5:
                        response = _b.sent();
                        if (response) {
                            this.showSuccessNotification();
                        }
                        else {
                            this.showErrorNotification();
                        }
                        return [3 /*break*/, 19];
                    case 6: return [4 /*yield*/, magic.methods.responsibleGaming.createUserWagerLimit(this.currencyCode, limitAmount, CoreXMediatorType.SPORTS)];
                    case 7:
                        response = _b.sent();
                        if (response) {
                            this.showSuccessNotification();
                        }
                        else {
                            this.showErrorNotification();
                        }
                        return [3 /*break*/, 19];
                    case 8: return [4 /*yield*/, magic.methods.responsibleGaming.createUserTransactionLimit(this.getUserTransactionLimitType(this.section), period, this.currencyCode, limitAmount, CoreXMediatorType.CASINO)];
                    case 9:
                        response = _b.sent();
                        if (response) {
                            this.showSuccessNotification();
                        }
                        else {
                            this.showErrorNotification();
                        }
                        return [3 /*break*/, 19];
                    case 10: return [4 /*yield*/, magic.methods.responsibleGaming.createUserTransactionLimit(this.getUserTransactionLimitType(this.section), period, this.currencyCode, limitAmount, CoreXMediatorType.SPORTS)];
                    case 11:
                        response = _b.sent();
                        if (response) {
                            this.showSuccessNotification();
                        }
                        else {
                            this.showErrorNotification();
                        }
                        return [3 /*break*/, 19];
                    case 12: return [4 /*yield*/, magic.methods.responsibleGaming.createUserTransactionLimit(this.getUserTransactionLimitType(this.section), period, this.currencyCode, limitAmount, CoreXMediatorType.SPORTS)];
                    case 13:
                        response = _b.sent();
                        return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 14:
                        currentJurisdiction = _b.sent();
                        if (!isUKGC(currentJurisdiction)) return [3 /*break*/, 16];
                        lastFinancialLimitReviewOnUtc = new Date();
                        return [4 /*yield*/, magic.methods.users.updateUserProfile({
                                lastFinancialLimitReviewOnUtc: lastFinancialLimitReviewOnUtc.toISOString(),
                            })];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        if (response) {
                            this.showSuccessNotification();
                        }
                        else {
                            this.showErrorNotification();
                        }
                        return [3 /*break*/, 19];
                    case 17: return [4 /*yield*/, magic.methods.responsibleGaming.createUserTransactionLimit(this.getUserTransactionLimitType(this.section), period, this.currencyCode, limitAmount, CoreXMediatorType.SPORTS)];
                    case 18:
                        response = _b.sent();
                        if (response) {
                            this.showSuccessNotification();
                        }
                        else {
                            this.showErrorNotification();
                        }
                        return [3 /*break*/, 19];
                    case 19: return [3 /*break*/, 22];
                    case 20:
                        e_1 = _b.sent();
                        this.showErrorNotification(e_1);
                        return [3 /*break*/, 22];
                    case 21:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 22: return [2 /*return*/];
                }
            });
        });
    };
    CreateLimitsComponent.prototype.initializeVariables = function () {
        return __awaiter(this, void 0, void 0, function () {
            var country, _a, limitPeriodConfig, maxCapConfig;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(USER_COUNTRY_QUERY)];
                    case 1:
                        country = _b.sent();
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(BALANCE_CURRENCY_QUERY)];
                    case 2:
                        _a.currencyCode = _b.sent();
                        return [4 /*yield*/, configQuery('limits.periodsAllowed')];
                    case 3:
                        limitPeriodConfig = _b.sent();
                        return [4 /*yield*/, configQuery('limits.maxCap')];
                    case 4:
                        maxCapConfig = _b.sent();
                        this.responsibleGamingLimitPeriods = objectValueOrDefault(limitPeriodConfig, country);
                        this.responsibleGamingLimitCap = objectValueOrDefault(maxCapConfig, this.currencyCode);
                        this.subscriptions.push(window.eventBus.subscribe(BALANCE_CURRENCY_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var currency;
                            var _a;
                            return __generator(this, function (_b) {
                                currency = (_a = event.payload) !== null && _a !== void 0 ? _a : Currency.EUR;
                                this.currencyCode = currency;
                                this.responsibleGamingLimitCap = objectValueOrDefault(maxCapConfig, currency);
                                return [2 /*return*/];
                            });
                        }); }, { replay: true }));
                        this.subscriptions.push(window.eventBus.subscribe(USER_COUNTRY_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var userCountry, enabledTypesConfig;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        userCountry = event.payload;
                                        return [4 /*yield*/, configQuery('limits.enabledTypes')];
                                    case 1:
                                        enabledTypesConfig = _a.sent();
                                        this.enabledLimits = objectValueOrDefault(enabledTypesConfig, userCountry);
                                        this.responsibleGamingLimitPeriods = objectValueOrDefault(limitPeriodConfig, userCountry);
                                        return [2 /*return*/];
                                }
                            });
                        }); }, { replay: true }));
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateLimitsComponent.prototype.showSuccessNotification = function () {
        notificationService.show(this.$t('create-limits.success'), {
            uniqueID: 'create-limits-success',
            style: NotificationStyle.SUCCESS,
        });
        this.routeTo({ route: RoutablePage.VIEW_LIMITS });
    };
    CreateLimitsComponent.prototype.showErrorNotification = function (e) {
        var _a, _b;
        var errorCode = typeof e === 'string' ? e : (_b = (_a = e === null || e === void 0 ? void 0 : e.errorCodes) === null || _a === void 0 ? void 0 : _a.$) === null || _b === void 0 ? void 0 : _b[0];
        var errorTranslationKey = limitErrors[errorCode] || 'error.generic';
        console.error('Create limits:', e);
        notificationService.show(this.$t(errorTranslationKey), {
            style: NotificationStyle.ERROR,
            uniqueID: 'create-limits-error',
        });
    };
    __decorate([
        ValidationGuard(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], CreateLimitsComponent.prototype, "setLimit", null);
    CreateLimitsComponent = __decorate([
        Component({
            name: 'corex-create-limits',
            validations: function () {
                var rules = {};
                var isDurationVisible = this.isInputVisible(this.section, Inputs.DURATION);
                var isAmountVisible = this.isInputVisible(this.section, Inputs.AMOUNT);
                if (isDurationVisible) {
                    rules.duration = {
                        required: required,
                        integer: integer,
                        minValue: minValue(30),
                        maxValue: maxValue(1440),
                    };
                }
                if (isAmountVisible) {
                    rules.amount = {
                        required: required,
                        integer: integer,
                        minValue: minValue(1),
                        maxValue: maxValue(this.getLimitCap()),
                    };
                }
                return rules;
            },
            store: store,
        })
    ], CreateLimitsComponent);
    return CreateLimitsComponent;
}(Mixins(validationMixin, MagicConfigMixin)));

export default CreateLimitsComponent;
